// Custom components
import {
  FieldValues,
  FieldErrors,
  ControllerRenderProps,
  RegisterOptions,
} from "react-hook-form";
import { NumericFormat } from "react-number-format";

function NumFormatField(props: {
  field: ControllerRenderProps<FieldValues, any>;
  id: string;
  label: string;
  extra: string;
  placeholder: string;
  variant: string;
  state?: string;
  disabled?: boolean;
  thousandSeparator: string;
  decimalSeparator: string;
  prefix?: string;
  suffix?: string;
  errors: FieldErrors<FieldValues>;
  rules: RegisterOptions<FieldValues>;
}) {
  const {
    field,
    label,
    id,
    extra,
    placeholder,
    variant,
    state,
    disabled,
    thousandSeparator,
    decimalSeparator,
    prefix,
    suffix,
    errors,
    rules,
  } = props;

  return (
    <div className={`${extra}`}>
      <label
        htmlFor={id}
        className={`text-sm text-navy-700 dark:text-white ${
          variant === "auth" ? "ml-1.5 font-medium" : "ml-3 font-bold"
        }`}
      >
        {" "}
        {label}
        {rules.required && (
          <span className="text-red-500 dark:text-red-400">*</span>
        )}
      </label>
      <NumericFormat
        id={id}
        value={field.value}
        onChange={field.onChange}
        thousandSeparator={thousandSeparator}
        decimalSeparator={decimalSeparator}
        prefix={prefix}
        placeholder={placeholder}
        suffix={suffix}
        disabled={disabled}
        className={`mt-2 flex h-12 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none transition-all duration-300 ${
          disabled === true
            ? "!border-none !bg-gray-100 dark:!bg-white/5 dark:placeholder:!text-[rgba(255,255,255,0.15)]"
            : state === "error" || errors[id]
            ? "border-red-500 text-red-500 placeholder:text-red-500 dark:!border-red-400 dark:!text-red-400 dark:placeholder:!text-red-400"
            : state === "success"
            ? "border-green-500 text-green-500 placeholder:text-green-500 dark:!border-green-400 dark:!text-green-400 dark:placeholder:!text-green-400"
            : "border-gray-200 dark:!border-white/10 dark:text-white"
        }`}
      />
      {errors[id] && (
        <span className="ml-2 mt-1 text-sm text-red-500 dark:text-red-400">
          {errors[id].message.toString()}
        </span>
      )}
    </div>
  );
}

export default NumFormatField;
